// Import Dependencies
import { Navigate, useLocation, useOutlet } from "react-router";

// Local Imports
import { useAuthContext } from "app/contexts/auth/context";
import { GHOST_ENTRY_PATH, REDIRECT_URL_KEY } from "../constants/app.constant";

// ----------------------------------------------------------------------

export default function AuthGuard() {
  const outlet = useOutlet();
  const { isAuthenticated } = useAuthContext();

  const location = useLocation();

  if (!isAuthenticated) {
    // Preserve ssotoken param so Login.jsx can auto-login via SSO
    const searchParams = new URLSearchParams(location.search);
    const ssoToken = searchParams.get("ssotoken");
    const loginTarget = ssoToken
      ? `${GHOST_ENTRY_PATH}?ssotoken=${encodeURIComponent(ssoToken)}`
      : `${GHOST_ENTRY_PATH}`;

    return <Navigate to={loginTarget} replace />;
  }

  return <>{outlet}</>;
}
